define('components/NewsletterSignup',[
    "jquery",
    "utilities",
    "logging"
], function ($, utilities, logging) {
    var _ModuleName = "Newsletter SignUp";
    var _ApiUri = "//www.patheos.com/ptapi/newsletter/subscribe";

    var _config = {
        leadConduit: {
            endpoint: "//classic.leadconduit.com/v2/PostLeadAction",
            accountId: "f8224e",
            test: false,
            response: {
                success: "success",
                queued: "queued",
                failure: "failure",
                error: "error"
            }
        }
    };
    
    $('#subNavSignupLink').click(function(){
        $('#subNavSignup').removeClass("hide");
    });

    $('.close-btn').click(function(){
        $('#subNavSignup').addClass("hide");
    });

    function NewsletterSignUp(scope, campaignId) {
        "use strict";

        var subdomain = location.hostname.split('.').shift();
        if (subdomain == "www")
            _ApiUri = "/ptapi/newsletter/subscribe";
        else if (subdomain == "local")
            _ApiUri = "http://local.patheos.com/ptapi/newsletter/subscribe";

        $("form.newsletter-signup-form", scope).submit(function (evt) {
            var $form = $(this);

            evt.stopPropagation && evt.stopPropagation();
            evt.preventDefault && evt.preventDefault();

            var email = $('input[name="email"]', $form).val();
            var isValidEmail = utilities.isAValidEmailAddress(email);

            ;
            ;

            if (isValidEmail) {

                $(".newsletter-signup-msgs", scope).html("<i class=\"fa fa-spinner fa-spin\" style=\"font-size:36px;\"></i>");

                // Set the partner mail flag to true if this is checked
                if ($("#newsletter-optin").is(":checked")) {
                    $('#newsletter-signup-form-head input[name="partners"]').val("true");
                } else {
                    $('#newsletter-signup-form-head input[name="partners"]').val("false");
                }

                // Fix checkbox to mark true if necessary
                $("input:checkbox[name='partners']:checked").val("true");
                
                try {
                    $.post(_ApiUri, $form.serialize(), function (data) {
                        ;

                        if (data.processed) {
                            // Submission was successful
                            $(".newsletter-signup-msgs", scope).html("<div class=\"alert alert-success\" role=\"alert\">Thank you for your subscription. You can visit your <a href=\"//www.patheos.com/subscribe/preference-center\">Preference Center</a> to complete your profile and see what else we have to offer.</div>");
                            $("#newsletter-signup-form-head", scope).html("");

                            // GTM Form Tracking
                            // https://www.simoahava.com/analytics/track-form-engagement-with-google-tag-manager/
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'formNewsletterSuccess',
                                formId: 'newsletter-signup-form-head'
                            });
                        }
                        else {
                            // Something went wrong
                            $(".newsletter-signup-msgs", scope).html("<div class=\"alert alert-warning\" role=\"alert\">We apologize, we were unable to complete your subscription at this time, please try again later. If this error persists please contact us at communications@patheos.com.</div>");
                        }
                    })
                    .fail(function( data ) {
                        $(".newsletter-signup-msgs", scope).html("<div class=\"alert alert-warning\" role=\"alert\">We apologize, we were unable to complete your subscription at this time, please try again later. If this error persists please contact us at communications@patheos.com.</div>");
                        ;
                      });

                    // If a campaign ID is assigned, pass to lead conduit
                    if(campaignId) {
                        ;
                        ;

                        var lead = {
                            xxAccountId: _config.leadConduit.accountId,
                            xxCampaignId: campaignId,
                            xxTest: _config.leadConduit.test,
                            email: email
                        };
                        $.post(_config.leadConduit.endpoint, lead, function (response) {
                            ;
                            if(response.result == _config.leadConduit.result.error) {
                                logging.error("Lead Conduit Submission Failed: " + response.reason, _ModuleName);
                            } else if(response.result == _config.leadConduit.result.success) {
                                ;
                            }
                        });
                    }
                } catch(e) {
                    ;
                    $(".newsletter-signup-msgs", scope).html("<div class=\"alert alert-warning\" role=\"alert\">Second occurence!!!!!!!!!!!!! We apologize, we were unable to complete your subscription at this time, please try again later. If this error persists please contact us at communications@patheos.com.</div>");
                }

            } else {
                $('.newsletter-signup-msgs', scope).html("<div class=\"alert alert-warning\" role=\"alert\">Please enter a valid email address.</div>");
            }
        });

        ;
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new NewsletterSignUp(args.scope, args.campaignId);
        }
    }
});
